import { observer } from 'mobx-react-lite';

import {
  namespaces,
  useSharedTranslation,
} from 'us-react-components/dist/hooks/useSharedTranslation';
import { useDependencies } from '../../../dependencies';
import { VoucherItem } from './VoucherItem';

export const ActiveCredits = observer((): JSX.Element | null => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { stores } = useDependencies();
  const { activeCredits } = stores.credits;

  if (!activeCredits || !activeCredits?.data?.data.length) {
    return null;
  }

  return (
    <div className='mb-4'>
      <h1 className='text-2xl font-semibold'>{t('pages.credits.activeCreditsHeader')}</h1>
      <p>{t('pages.credits.activeCreditsDescription')}</p>
      <VoucherItem userVouchers={activeCredits} />
    </div>
  );
});
